// src/components/TermsOfService.js
// Legacy file — delegates to the canonical Termly-backed component.
import React from 'react';
import TermlyEmbed from './policies/TermlyEmbed';

const TermsOfService = () => (
  <TermlyEmbed dataId="bfaba905-3b80-44c6-aadb-ba01fda339ac" />
);

export default TermsOfService;
